import { useContext } from 'react';
import { Route, Redirect, useLocation } from 'react-router';
import { AuthContext } from '../components/auth-context/auth-context';
import routeConfig from './routeConfig';

// @ts-ignore
export const ProtectedRoute = ({ component: Component, ...rest }) => {
	const location = useLocation();

	const authContext = useContext(AuthContext);

	return (
		<Route
			{...rest}
			render={(props) => {
				if (
					authContext.isAuthenticated ||
					localStorage.getItem('login-test') !== null
				) {
					if (authContext.userProfile === null) {
						if (
							location.pathname.match(routeConfig.dashboard) ||
							location.pathname.match(
								routeConfig.requestSignature,
							)
						) {
							return <Component {...props} />;
						} else {
							return (
								<Redirect
									to={{
										pathname: routeConfig.dashboard,
										state: {
											from: props.location,
										},
									}}
								/>
							);
						}
					} else {
						return <Component {...props} />;
					}
				} else {
					return (
						<Redirect
							to={{
								pathname: '/',
								state: {
									from: props.location,
								},
							}}
						/>
					);
				}
			}}
		/>
	);
};
